import {Autocomplete, Box, Stack, IconButton} from '@mui/material';
import {styled} from '@mui/material/styles';
import PropTypes from 'prop-types';
import AppTextField from './AppTextField';
import {KeyboardArrowDown} from "@mui/icons-material";
import RpIcon from "@/components/RpIcon.jsx";
// ----------------------------------------------------------------------

const RootStyle = styled(Autocomplete)(({iconwidth}) => ({
  'position': 'relative',
  'label': {
    // paddingLeft: `${iconwidth}px`,
    '&.MuiInputLabel-shrink': {
      paddingLeft: '0 !important',
    }
  },
  'input': {
    paddingLeft: `${iconwidth}px !important`,
  },
  '.MuiOutlinedInput-root': {
    paddingRight: '8px!important'
  }
}));

export default function StartElAutoComplete({
                                              showIcon = false, icon = null, fullWidth = false, label = '',
                                              iconWidth = 42, iconHeight = 42, required = false, error = false, ...other
                                            }) {
  const getIconEl = (params) => {
    return showIcon ? <Stack direction={'row'} alignItems={'center'}>
      <Box sx={{position: 'absolute', zIndex: 1, paddingLeft: 2, bottom: '10px'}}>
        {icon}
      </Box>
      <AppTextField
        {...params}
        label={label}
        required={required}
        error={error}
        endAdornment={
          <RpIcon icon={'arrow-down-simple'} />
        }
        inputProps={{
          ...params.inputProps,
          autoComplete: 'off',
        }}

      />
    </Stack> : <AppTextField
      {...params}
      label={label}
      required={required}
      error={error}
      inputProps={{
        ...params.inputProps,
        autoComplete: 'off',
      }}
    />
  }

  return <RootStyle
    iconwidth={iconWidth} iconheight={iconHeight}
    {...other}
    sx={{width: fullWidth ? '100%' : 300}}
    renderInput={getIconEl}
  />;
}

StartElAutoComplete.propTypes = {
  showIcon: PropTypes.bool,
  icon: PropTypes.node,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  required: PropTypes.bool,
  error: PropTypes.bool,
}
